import { render } from "./AcelerometroEquipo.vue?vue&type=template&id=fdccba94"
import script from "./AcelerometroEquipo.vue?vue&type=script&lang=js"
export * from "./AcelerometroEquipo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maguilar/Dev/repos/garantias-transelec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__